import { Component, HostBinding, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FileModel } from 'src/app/core/services/api-services';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  @HostBinding('class')
  cssClass = 'avatar';

  @Input()
  image: FileModel | null | undefined; 

  @Input()
  firstName: string | undefined;

  @Input()
  lastName: string | undefined;

  constructor(private readonly sanitizer: DomSanitizer) {}

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  get initials(): string {
    return `${this.firstName?.charAt(0) || '?'}${this.lastName?.charAt(0) || '?'}`;
  }

  get imageSrc(): SafeResourceUrl {
    const objectUrl = `data:${this.image!.type};base64,${this.image!.data}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
  }
}
